// Angular 2
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';

import 'rxjs';
import '@angularclass/hmr';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...

import 'ng2-responsive';
import 'ng2-slim-loading-bar';
import 'ng2-webstorage';
import 'ng2-img-cropper';
import 'angulartics2';
import 'serialijse/lib/serialijse.js';


// import 'braintree-web'; // Versione 2.x DA ERRORE QUANDO MINIFICATO

/*number-picker*/
// import 'angular-number-picker.js';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/vendor.ts